import styled from "styled-components";

type FormComponentWrapperProps = {
  withoutGaps?: boolean;
};

export const FormComponentContainer = styled.div<FormComponentWrapperProps>`
  display: flex;
  flex-direction: column;
  padding: 0 28px;
  gap: ${(props: any) => !props.withoutGaps && "10px"};
  color: #2b2b2b;
`;

export const StyledErrorContainer = styled.div`
  display: flex;
  padding: var(--space-050, 4px) var(--space-150, 12px);
  align-items: flex-start;
  gap: var(--space-0, 0px);
  align-self: stretch;
  border-radius: var(--radius-0, 0px);
  border-left: 2px solid var(--stroke-state-danger-default, #E4251B);
  background: var(--surface-state-danger-lightest, #FFF2F1);
`;

export const StyledErrorLabel = styled.label`
  flex: 1 0 0;
  color: var(--content-state-danger-dark, #9F1C15);

  /* Small */
  font-family: Inter;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px; /* 200% */
`;
